import type { FC } from 'react';
// components
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';
import { Button } from '@interstate/components/Button';
import { Box } from '@interstate/components/Box';
import { COMPONENT_ID, TEMPLATE_HEADER_V2 } from './constants';
import TemplateSaveStatusDialogV2Content from './TemplateSaveStatusDialogV2Content';
import { createSaveNewTemplateEvent } from '../analytics/cdlEventCreators';
import { useDispatch } from 'react-redux';

// styles
import { ButtonContainer, ContentContainer } from './TemplateSaveStatusDialog.style';

export type TemplateSaveStatusDialogProps = {
    show: boolean;
    onHide: () => void;
    savePaymentTerms: boolean;
    toggleSavePaymentTerms: (enabled: boolean) => void;
    handleSave: () => void;
};

const TemplateSaveStatusDialog: FC<TemplateSaveStatusDialogProps> = ({
    show,
    onHide,
    savePaymentTerms,
    toggleSavePaymentTerms,
    handleSave
}) => {
    const dispatch = useDispatch();

    const toggleEnablePaymentDetails = () => {
        toggleSavePaymentTerms(!savePaymentTerms);
    };

    const handleSaveClick = () => {
        dispatch(createSaveNewTemplateEvent());
        handleSave();
    };

    return (
        <>
            <Modal
                size="large"
                id={COMPONENT_ID}
                data-testid={COMPONENT_ID}
                show={show}
                sx={{
                    '.interstate-x-mark-icon': {
                        cursor: 'pointer'
                    }
                }}
                header={
                    <Box mt={0.5}>
                        <Typography variant="h3" data-testid={`${COMPONENT_ID}-header`}>
                            {TEMPLATE_HEADER_V2}
                        </Typography>
                    </Box>
                }
                onHide={onHide}
            >
                <ContentContainer>
                    <TemplateSaveStatusDialogV2Content
                        savePaymentTerms={savePaymentTerms}
                        toggleSavePaymentTerms={toggleEnablePaymentDetails}
                    />
                    <ButtonContainer>
                        <Box mr={1}>
                            <Button
                                buttonStyle="tertiary"
                                data-testid={`${COMPONENT_ID}-cancel-button`}
                                size="default"
                                onClick={onHide}
                            >
                                Cancel
                            </Button>
                        </Box>
                        <Button data-testid={`${COMPONENT_ID}-confirm-button`} size="default" onClick={handleSaveClick}>
                            Save Template
                        </Button>
                    </ButtonContainer>
                </ContentContainer>
            </Modal>
        </>
    );
};

export default TemplateSaveStatusDialog;
